import api from '../config/axiosConfig';

export const subserviceService = {
    getAll: (serviceId) => api.get(`/services/${serviceId}/subservices`),
    get: (serviceId, id) => api.get(`/services/${serviceId}/subservices/${id}`),
    create: (serviceId, subserviceData) => api.post(`/services/${serviceId}/subservices`, subserviceData),
    update: (serviceId, id, subserviceData) => api.put(`/services/${serviceId}/subservices/${id}`, subserviceData),
    delete: (serviceId, id) => api.delete(`/services/${serviceId}/subservices/${id}`)
};